import { render, staticRenderFns } from "./UserBecome.vue?vue&type=template&id=40627a7f"
import script from "./UserBecome.vue?vue&type=script&lang=js"
export * from "./UserBecome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports